module.exports = __webpack_public_path__ + "static/media/price-tag.feae9798.svg";